<div class="content" #inputDisplay>
  <app-input-box
    [name]="name"
    [label]="label"
    [(value)]="text"
    [placeholder]="placeholder"
    [disabled]="!!disabled"
    [readOnly]="!searchEnabled"
    [showErrorEnabled]="!!showErrorEnabled"
    [showClearButton]="!!showClearButton"
    [clearButtonEnabled]="!readOnly"
    (onClearClick)="onInputClear()"
    (onInput)="onInputValue($event)"
    (onFocus)="onInputFocus($event)"
    (onKeydown)="onKeydown.emit($event)"
    (click)="onInputBoxClick()"
  >
    <app-button
      appFieldSuffix
      class="btn-opened-indicator"
      [ngClass]="{ opened }"
      *ngIf="showOpenedIndicatorButton"
      buttonType="normal"
      styleType="text"
      shapeType="circle"
      sizeType="x-small"
      icon="assets/icons/chevron-down.svg"
      (click)="onBtnToggleClick()"
    ></app-button>

    <ng-container appFieldSuffix>
      <ng-content select="[appFieldSuffix]"></ng-content>
    </ng-container>
  </app-input-box>
</div>

<app-dropdown
  [opened]="opened"
  (openedChange)="onDropdownOpenChange($event)"
  [target]="inputDisplay"
  [width]="dropdownWidth"
>
  <ng-template dropdownContent>
    <app-list
      class="selectable-list"
      [items]="_resultItems"
      [keyExpr]="valueExpr"
      [animate]="false"
    >
      <ng-template listItem let-item="item" let-index="index" let-key="key">
        <div
          class="list-item"
          [ngClass]="{ selected: key === value }"
          (click)="onListItemClick($event, item, index, key)"
        >
          {{ extractDisplay(item, index) }}
        </div>
      </ng-template>
    </app-list>
  </ng-template>
</app-dropdown>
